import React, { Component } from 'react';
import {Link} from 'react-router-dom';
import '../App.css';

import EndOfProject from './EndOfProject';

import code_icon from '../Images/code-icon.svg';
import arrow_icon from '../Images/arrow-icon.svg';
import puzzle_icon from '../Images/puzzle-icon.svg';
import shopping_icon from '../Images/shopping-icon.svg';
import database_icon from '../Images/database-icon.svg';
import shirt_icon from '../Images/shirt-icon.svg';

import projectcomm from '../Images/communitee-project.jpg';
import communiteeshirts from '../Images/communitee-shirts.jpg';
import communiteeplatform from '../Images/communitee-platform.jpg';
import communiteeshop from '../Images/communitee-shop.jpg';
import communiteescreens from '../Images/communitee-screens.jpg';
import communiteedemo from '../Images/communitee-demo.jpg';
import communiteecode from '../Images/communitee-code.jpg';

class ProjectCommunitee extends Component {
  
    constructor(props) {
        super();
        this.props = props;
    }
  
  componentDidMount() {
    window.scrollTo(0, 0);
  }

  componentWillUnmount(){

  }

  visitWebsite() {
    window.location.href = "https://communitee.io/shirt-1";
  }

  render () {
    
    const footerYear = new Date().getUTCFullYear();

    return (
        
      <div id="project">

        <div className="project-content-top">
          
            <p className="project-title-large">Communitee.io: Messaging Platform and E-Commerce Store</p>
            <img className="project-image-rounded-2" src={projectcomm} alt=""></img>

            <div className="project-text-container">
              <p className="project-text-medium">Summary</p>
            </div>
            <div className="project-overview">
              <div className="project-overview-left">
                <div className="project-text-container-2">
                  <p className="project-text-small">Mission</p>
                  <p className="project-paragraph">I set out to build Communitee.io, the first messaging platform located on your shirt. People have enjoyed wearing QR codes in the past that link to static messages in your browser, but I wanted to create a platform to make it dynamic and editable. By scanning the QR code on my shirts, you can reveal the personalized message along with the ability to edit it! Shirts could be purchased on the website and fulfilled through my print-on-demand partners.</p>
                </div>
                <div className="project-text-container-2">
                  <p className="project-text-small">My Contributions</p>
                  <p className="project-paragraph">I developed the application and e-commerce store in Angular, and built the back-end for reading and writing messages using a Dynamo DB database. I provided users with a smooth ordering flow, and an engaging messaging experience on this new communication platform. </p>
                </div>
              </div>
              <div className="project-overview-right">
                <div className="project-text-container-3">
                  <p className="project-text-small">Link</p>
                  <div className="button" onClick={(e) => {this.visitWebsite()}}>
                    <p>Communitee.io Shirt</p>
                    <img className="button-icon" src={arrow_icon} alt=""></img>
                  </div>
                </div>

                <div className="project-text-container-3">
                  <p className="project-text-small">My Tasks</p>

                  <div className="icon-bullet">
                    <img className="bullet-icon" src={code_icon} alt=""></img>
                    <p className="project-paragraph">Angular Programming</p>
                  </div>
                  <div className="icon-bullet">
                    <img className="bullet-icon" src={shopping_icon} alt=""></img>
                    <p className="project-paragraph">E-Commerce UX Design</p>
                  </div>
                  <div className="icon-bullet">
                    <img className="bullet-icon" src={database_icon} alt=""></img>
                    <p className="project-paragraph">Dynamo Database Dev</p>
                  </div>
                  <div className="icon-bullet">
                    <img className="bullet-icon" src={puzzle_icon} alt=""></img>
                    <p className="project-paragraph">AWS Full-Stack Engineering</p>
                  </div>
                  <div className="icon-bullet">
                    <img className="bullet-icon" src={shirt_icon} alt=""></img>
                    <p className="project-paragraph">Print-On-Demand Services</p>
                  </div>
                </div>

              </div>
            </div>
        </div>

        <div className="project-content">
          
          <div className="project-chunk">
            <div className="project-text-container">
              <p className="project-text-medium">Ideation</p>
              <p className="project-paragraph">The idea for Communitee.io stemmed from my interest in people's curiosity with scanning QR codes in unconventional places, like on t-shirts. People have enjoyed wearing QR codes in the past that link to static messages, but I wanted to create a message that could be dynamic and editable. Thus the idea was born for a t-shirt message that users could view and edit by scanning the QR code. Each message can be read and rewritten by anyone that scans the t-shirt — that's why it's called a Communi-Tee.</p>
            </div>
            <img className="project-image-nobordered" src={communiteeshirts} alt=""></img>
          </div>

          <div className="project-chunk">
            <div className="project-text-container">
              <p className="project-text-medium">The Message Platform</p>
              <p className="project-paragraph">The message platform is accessed by scanning the QR code on apparel in my store. The application launches in a web browser and provides the ability to read and write a personalized message.</p>
            </div>
            <img className="project-image-nobordered" src={communiteeplatform} alt=""></img>
          </div>

          <div className="project-chunk">
            <div className="project-text-container">
              <p className="project-text-medium">E-Commerce Store</p>
              <p className="project-paragraph">I designed and developed an online store for purchasing t-shirts, hoodies, tanks, and other apparel, each with the Communitee.io QR code. I integrated the PayPal API for handling secure transactions via credit/debit card, PayPal, and Venmo. I fulfill all orders through professional print-on-demand partners for high-quality manufactured apparel.</p>
            </div>
            <img className="project-image-nobordered" src={communiteeshop} alt=""></img>
          </div>

          <div className="project-chunk">
            <div className="project-text-container">
              <p className="project-text-medium">Website Architecture</p>
              <p className="project-paragraph">Communitee.io allows users to navigate to webpages that introduce the product to prospective customers, with CTAs crafted to funnel users to the shop for purchasing their own t-shirt.</p>
            </div>
            <img className="project-image-bordered" src={communiteescreens} alt=""></img>
          </div>

          <div className="project-chunk">
            <div className="project-text-container">
              <p className="project-text-medium">Free Demo</p>
              <p className="project-paragraph">I created a marketing strategy that gives free access to the Communitee.io application in a demo environment. Allowing users to try features for free gives them a good understanding of what they will be paying for, reduced ambiguity about what to expect, and converts prospective customers. </p>
            </div>
            <img className="project-image-nobordered" src={communiteedemo} alt=""></img>
          </div>

          <div className="project-chunk">
            <div className="project-text-container">
              <p className="project-text-medium">Database Management</p>
              <p className="project-paragraph">I setup a Dynamo DB database in AWS to store user-generated messages. I used AWS Identity Pools to get tokens for assuming roles with web identity. Then using temporary credentials, users can retrieve database credentials via Secrets Manager to execute commands on the Dynamo database.</p>
            </div>
          </div>

          <div className="project-chunk">
            <div className="project-text-container">
              <p className="project-text-medium">Angular Programming</p>
              <p className="project-paragraph">Communitee.io is an Angular application primarily developed using TypeScript as well as HTML and CSS. It makes use of classes, services, modules, components, data-binding, dependancy injection, APIs, routing, and component lifecycles.</p>
            </div>
            {/* <img className="project-image-nobordered" src={communiteecode} alt=""></img> */}
          </div>

          <EndOfProject/>
  
        </div>
                
      </div>
    );
  }
}

export default ProjectCommunitee;
